import { render, staticRenderFns } from "./ChangePostingDateAndAmount.vue?vue&type=template&id=236479af&"
import script from "./ChangePostingDateAndAmount.vue?vue&type=script&lang=js&"
export * from "./ChangePostingDateAndAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports